import React from "react";
import {LogoIcon, MangroveIcon} from "../assets/icons/Icons";
import netezis from "../assets/images/netezis_white_nobg.svg";
import facebook from "../assets/images/facebook.svg";
import instagram from "../assets/images/instagram.svg";
import youtube from "../assets/images/youtube.svg";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

function Footer() {
    const { t } = useTranslation();
    return (
        <section className={"flex flex-col justify-start items-center w-full"}>
            <div className={"flex flex-col justify-start items-center w-full pb-[60px]"}>
                <LogoIcon size={100}/>
                <div className={"flex flex-row justify-start items-center gap-[1px] pt-[30px]"}>
                    <a href={"https://www.facebook.com/korutiorvosicentrum/"} target={"_blank"} aria-label="Facebook" rel={"noopener nofollow noreferrer"}
                       className={"group flex justify-center items-center p-2 rounded-full transition-all duration-300 hover:bg-[#dcc7bf]"}>
                        <img src={facebook} width={17} height={17} alt={"Facebook"}/>
                    </a>
                    <a href={"https://www.instagram.com/koruti.orvosi.centrum/"} target={"_blank"} aria-label="Instagram" rel={"noopener nofollow noreferrer"}
                       className={"group flex justify-center items-center p-2 rounded-full transition-all duration-300 hover:bg-[#dcc7bf]"}>
                        <img src={instagram} width={17} height={17} alt={"Instagram"}/>
                    </a>
                    <a href={"https://www.youtube.com/channel/UC-JYVlxc8T_2vuRzmC6Q92A"} aria-label="Youtube" target={"_blank"} rel={"noopener nofollow noreferrer"}
                       className={"group flex justify-center items-center p-2 rounded-full transition-all duration-300 hover:bg-[#dcc7bf]"}>
                        <img src={youtube} width={17} height={17} alt={"Youtube"}/>
                    </a>
                </div>
            </div>
            <div className={"flex justify-center items-center w-full bg-primary py-[50px]"}>
                <div
                    className={"w-[90%] 2xl:w-[80%] 2xl:container flex flex-col lg:flex-row justify-between items-center gap-10 lg:gap-0"}>
                    <span className={"text-white text-[12px] font-source-sans"}>{t('footer.copy_right')} © Körúti Orvosi Centrum Kft. 2024</span>
                    <div className={"flex justify-start items-center gap-3"}>
                        <Link to={"/adatvedelmi-tajekoztato/"} className={"transition-all duration-300 text-white text-[12px] font-source-sans hover:text-white/60 hover:cursor-pointer"}>{t('footer.privacy_policy')}</Link>
                        <span className={"text-white text-[12px] font-source-sans"}>-</span>
                        <Link to={"/impresszum/"} className={"transition-all duration-300 text-white text-[12px] font-source-sans hover:text-white/60 hover:cursor-pointer"}>{t('footer.impressum')}</Link>
                    </div>
                    <div className={"flex justify-start items-center gap-10"}>
                        <a href={"https://netezis.hu"} target={"_blank"} aria-label="Netezis Kft." rel={"nofollow noopener noreferrer"}>
                            <img src={netezis} width={120} height={30} alt={"Netezis Kft."}/>
                        </a>
                        <a href={"https://mangrovemarketing.hu"} aria-label="Mangrove Marketing" target={"_blank"} rel={"nofollow noopener noreferrer"}>
                            <MangroveIcon width={120} height={30} className={"h-auto"}/>
                        </a>
                    </div>
                </div>
            </div>
        </section>
);
};

export default Footer;